export default {
    workOrder_locationTab_name: "Name",
    workOrder_locationTab_type: "Type",
    workOrder_locationTab_address: "Address",
    workOrder_locationTab_description: "Description",
    workOrder_locationTab_createdOn: "Created At",
    workOrder_locationTab_warningDeleteLocation: "It is not possible to delete the main location",
    workOrder_locationTab_deleteLocations: "Delete Locations",
    workOrder_locationTab_regular: "Regular",
    workOrder_locationTab_main: "Main",
    workOrder_locationTab_billing: "Billing",
}